import React from 'react';
export var Arrow = function (_a) {
    var expanded = _a.expanded;
    return (React.createElement("svg", { width: "24", height: "24", fill: "none", stroke: "currentColor", strokeWidth: "2", className: "dropdown-heading-dropdown-arrow gray" },
        React.createElement("path", { d: expanded ? 'M18 15 12 9 6 15' : 'M6 9L12 15 18 9' })));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/MultiSelect/multi-select/Arrow.tsx
// module id = 1200
// module chunks = 0